export default __webpack_public_path__ + "static/media/Animals_04.45660a9d.png";